export function getAssetUrl (type:string = '', file:string) {
  let folder = 'files'
  if (type === 'logo') folder = 'logos'
  if (type === 'documentAttachment') folder = 'files'
  if (type === 'correctAnswerSound' || type === '' || type === 'timeoutSoundFile') folder = 'sounds'
  if (type === 'backgroundImage' || type === 'pointsHeaderImage' || type === 'pointsMissionGroupImage') folder = 'images'
  if (type === 'icon') folder = 'icons'
  if (type === 'imageFull' || type === 'imageMedium' || type === 'imageSmall') folder = 'images'
  if (type === 'image') folder = 'images'
  if (type === 'sound') folder = 'sounds'
  if (type === 'game') folder = 'games'

  if (file?.includes('https://')) return file

  return `${process.env.REACT_APP_ASSETS_URL}/${folder}/${file}`
}
